/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import ExternalLinkIcon from 'assets/icons/external-link-icon'
import OptionIcon from 'assets/icons/options-icon'
import capitalize from 'utils/capitalize'
import { getStickyTableColumnsLength } from 'utils/getStickyTableColumnsLength'
import { ReportsFactsheetIconWrapper, ReportsFactsheetWrapper } from '../style'
import { renderSitesStatusIcon } from '../../SitesManagement/sitesTable'
import { SortingArrowWrapper } from 'components/SortingArrow/style'

export const makePressuresTabRow = (tableData) => {
  if (!Array.isArray(tableData)) {
    return []
  }

  return tableData.map((item) => {
    const siteStatus = item.kbaStatus
    return {
      siteCode: item.siteCode || item.SiteId || item.siteId || '-',
      region: Array.isArray(item.region) ? item.region.join(', ') : (item.region || '-'),
      country: Array.isArray(item.country) ? item.country.join(', ') : (item.country || item.countryLabel || '-'),
      siteName: item.siteName || item.siteNameEng || '-',
      year: item.year != null ? item.year : '-',
      SiteStatusId: (
        <>
          {renderSitesStatusIcon(siteStatus)}
          {capitalize(siteStatus)}
        </>
      ),
      kbaClassification: item.kbaClassification || '-',
      pressureLevel1: item.pressureLevel1 || '-',
      pressureLevel2: item.pressureLevel2 || '-',
      pressureLevel3: item.pressureLevel3 || '-',
      timing: item.timing || '-',
      options: (
        <ReportsFactsheetWrapper>
          <ReportsFactsheetIconWrapper>
            <ExternalLinkIcon />
          </ReportsFactsheetIconWrapper>
          <ReportsFactsheetIconWrapper>
            <OptionIcon />
          </ReportsFactsheetIconWrapper>
        </ReportsFactsheetWrapper>
      )
    }
  })
}

export const makePressuresTabColumns = (sorting, setSorting, rows = []) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortBySiteId = () => {
    sortFunction('siteCode')
  }

  const sortByRegion = () => {
    sortFunction('region')
  }

  const sortByCountry = () => {
    sortFunction('country')
  }

  const sortBySiteName = () => {
    sortFunction('siteName')
  }

  const sortByAssessmentDate = () => {
    sortFunction('year')
  }

  const sortByKbaStatus = () => {
    sortFunction('SiteStatusId')
  }

  const sortByKbaClassification = () => {
    sortFunction('kbaClassification')
  }

  const sortByPressureLevel1 = () => {
    sortFunction('pressureLevel1')
  }

  const sortByPressureLevel2 = () => {
    sortFunction('pressureLevel2')
  }

  const sortByPressureLevel3 = () => {
    sortFunction('pressureLevel3')
  }

  const sortByTiming = () => {
    sortFunction('timing')
  }

  return [
    {
      id: 'siteCode',
      sticky: 'left',
      width: getStickyTableColumnsLength('siteCode', rows, 130),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteId' />
          <SortingArrow
            onChange={sortBySiteId}
            checked={sorting.sortBy === 'siteCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteCode',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'region',
      width: getStickyTableColumnsLength('region', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='region' />
          <SortingArrow
            onChange={sortByRegion}
            checked={sorting.sortBy === 'region' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'region',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      width: getStickyTableColumnsLength('country', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='country' />
          <SortingArrow
            onChange={sortByCountry}
            checked={sorting.sortBy === 'country' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'country',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      width: getStickyTableColumnsLength('siteName', rows, 200),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='internationalName' />
          <SortingArrow
            onChange={sortBySiteName}
            checked={sorting.sortBy === 'siteName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'year',
      width: getStickyTableColumnsLength('year', rows, 180),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='yearOfAssessment' />
          <SortingArrow
            onChange={sortByAssessmentDate}
            checked={sorting.sortBy === 'year' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'year',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SiteStatusId',
      width: getStickyTableColumnsLength('SiteStatusId', rows, 150),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaStatus' />
          <SortingArrow
            onChange={sortByKbaStatus}
            checked={sorting.sortBy === 'SiteStatusId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'SiteStatusId',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaClassification',
      width: getStickyTableColumnsLength('kbaClassification', rows, 175),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaClassification' />
          <SortingArrow
            onChange={sortByKbaClassification}
            checked={sorting.sortBy === 'kbaClassification' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'kbaClassification',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'pressureLevel1',
      width: getStickyTableColumnsLength('pressureLevel1', rows, 220),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='pressureLevel1' />
          <SortingArrow
            onChange={sortByPressureLevel1}
            checked={sorting.sortBy === 'pressureLevel1' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'pressureLevel1',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'pressureLevel2',
      width: getStickyTableColumnsLength('pressureLevel2', rows, 220),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='pressureLevel2' />
          <SortingArrow
            onChange={sortByPressureLevel2}
            checked={sorting.sortBy === 'pressureLevel2' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'pressureLevel2',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'pressureLevel3',
      width: getStickyTableColumnsLength('pressureLevel3', rows, 220),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='pressureLevel3' />
          <SortingArrow
            onChange={sortByPressureLevel3}
            checked={sorting.sortBy === 'pressureLevel3' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'pressureLevel3',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'timing',
      width: getStickyTableColumnsLength('timing', rows, 180),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='timing' />
          <SortingArrow
            onChange={sortByTiming}
            checked={sorting.sortBy === 'timing' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'timing',
      cell: ({ getValue }) => getValue()
    }
  ]
}
